import { getField } from 'vuex-map-fields'
import Validation from '../../../services/Validation'

// This value won't change between page loads. That's ok.
const userPrefersDark =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export default {
  getField,
  isManagedApp: state => {
    return Validation.isManagedApplication(state.app)
  },
  usedFields: state => (): Array<any> => {
    return _.concat(state.fieldsInCode || [], state.flow.anchors || [])
  },
  areChildrenComponentsValid: state => (): boolean => {
    const flowTriggers = state.childComponentsValidation.flowTriggers
    return Object.keys(flowTriggers).reduce((acc, type) => {
      return !_.some(flowTriggers[type], { isValid: false }) && acc
    }, true)
  },
  isDarkThemeActive: (state, getters, rootState, rootGetters) => {
    const userPreferences = rootGetters.userPreferences
    return (
      ((userPreferences.preferDarkEditor == null ||
        userPreferences.preferDarkEditor === 'browser') &&
        userPrefersDark) ||
      userPreferences.preferDarkEditor === 'dark'
    )
  }
}
